// --------------------------------------------------
// County Map — two-way hover/focus sync between the "counties included" list
// and the SVG map. Each county shape and its list item share a
// data-county="<Name>" attribute; hovering or focusing either one toggles
// `.is-active` on both (styled the same as :hover in _county-map.scss).
// --------------------------------------------------

function initCountyMap() {
  document.querySelectorAll('[data-county-map]').forEach((root) => {
    const items = root.querySelectorAll('[data-county]');
    const byName = {};

    items.forEach((el) => {
      const name = el.getAttribute('data-county');
      (byName[name] = byName[name] || []).push(el);
    });

    items.forEach((el) => {
      const name = el.getAttribute('data-county');
      const toggle = (on) => {
        byName[name].forEach((match) => match.classList.toggle('is-active', on));
      };

      el.addEventListener('mouseenter', () => toggle(true));
      el.addEventListener('mouseleave', () => toggle(false));
      el.addEventListener('focus', () => toggle(true));
      el.addEventListener('blur', () => toggle(false));
    });
  });
}

if (document.readyState !== 'loading') {
  initCountyMap();
} else {
  document.addEventListener('DOMContentLoaded', initCountyMap);
}
